import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 32px;
    margin: 0 auto;
    overflow: auto;
`;

export const ButtonSection = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 32px;
    margin-top: 24px;

    @media (max-width: 768px) {
        flex-direction: column;
    }

    @media (min-width: 769px) {
        flex-wrap: wrap;
        
        & > div {
            flex: 1;
            min-width: 220px; 
        }
    }
`;

export const SectionTitle = styled.h3`
    margin-bottom: 12px;
    font-size: 18px;
    color: #333;
`;

export const ButtonGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const ActionButton = styled.button`
    padding: 16px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    background-color: ${({ type }) => {
        if (type === "danger") return "#f44336";
        if (type === "debug") return "#ff9800";
        return "#61cbc9";
    }};
    color: white;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s;

    &:hover {
        background-color: ${({ type }) => {
        if (type === "danger") return "#d32f2f";
        if (type === "debug") return "#e68900";
        return "#47b5ab";
    }};
    }
`;